import { createContext, useContext } from 'react';
import { db } from '../lib/db';
import { storage } from '../lib/storage';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  // Use InstantDB's useAuth hook directly
  const { isLoading, user, error } = db.useAuth();
  
  // Update storage with current user
  if (user) {
    storage.setCurrentUser(user);
  } else {
    storage.setCurrentUser(null);
  }

  const syncStatus = user ? 'online' : 'offline';

  const signIn = async (email) => {
    try {
      await db.auth.sendMagicCode({ email });
      return { success: true };
    } catch (error) {
      console.error('Sign in error:', error);
      return { success: false, error: error.body?.message || error.message };
    }
  };

  const verifyCode = async (email, code) => {
    try {
      await db.auth.signInWithMagicCode({ email, code });
      return { success: true };
    } catch (error) {
      console.error('Verify code error:', error);
      return { success: false, error: error.body?.message || error.message };
    }
  };

  const signOut = async () => {
    try {
      await db.auth.signOut();
      storage.setCurrentUser(null);
    } catch (error) {
      console.error('Sign out error:', error);
    }
  };

  return (
    <AuthContext.Provider value={{ 
      user, 
      isLoading, 
      error,
      syncStatus,
      signIn, 
      verifyCode, 
      signOut,
      isAuthenticated: !!user
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
}
